import React, { useEffect, useState } from "react";
import { descriptionStates } from "../utils/constants";

import { DescriptionInterface } from "../types/DescriptionInterface";

const Description = ({
  data,
  state,
  selectedIndex,
  handleTouchStart,
  handleTouchMove,
}: DescriptionInterface) => {
  const [copy, setCopy] = useState(data[selectedIndex]);
  useEffect(() => {
    if (state === descriptionStates.SHOW) {
      setCopy(data[selectedIndex]);
    }
  }, [state, selectedIndex, data]);

  return (
    <div
      className={`desc ${state === descriptionStates.SHOW ? "active" : ""}`}
      onTouchStart={(event) => { if (handleTouchStart) handleTouchStart(event)}}
      onTouchMove={(event) => { if (handleTouchMove) handleTouchMove(event)}}
    >
      <div className="copy-container">
        <div>
          <h4 className="title title-font">{copy.title}</h4>
          <div className="description">
            <p className="copy copy-font">{copy.desc}</p>
            {copy.note && (
              <p
                className="note copy copy-font"
                dangerouslySetInnerHTML={{ __html: copy.note }}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Description;
